import { useEffect, useState } from 'react';
import { authTokenService } from '@/bundle/shared/services/authTokenService';
import { decodeToken } from '@/helpers/tokenHelpers';
import { AccessTokenType } from '@/types/sharedTypes';

export const useHasAnyOrganizationAdminRole = () => {
  const [hasAnyOrganizationAdminRole, setHasAnyOrganizationAdminRole] = useState(null);

  useEffect(() => {
    const tokens = authTokenService.getTokens();

    if (!tokens || !tokens?.access) return;

    const { existing_roles } = decodeToken<AccessTokenType>(tokens?.access);

    setHasAnyOrganizationAdminRole(!!existing_roles?.organization_user);
  }, []);

  return { hasAnyOrganizationAdminRole };
};
